export const searchConfig = {
  fields: ["name"],
  storeFields: ["name", "type", "url", "isActive", "isPublic", "sourceId", "sourceName", "sourceUrl"],
  searchOptions: {
    prefix: true,
    fuzzy: 0.2
  }
};
